module.exports = __webpack_public_path__ + "static/logo-c2bc07dd41a37fbebb69f1ab2d973fb0.svg";